// if(activate_new == 'true'){
//   let executeOldcode = false;
// }else{
//   let executeOldcode = true;
// }

// let executeOldcode = true;


$(document).ready(function () {
    $('.product-modal-open').on('click', function () {
        $('.product-modal').addClass('active');
    })

    $('.product-close-modal, .close-modal-wrap').on('click', function () {
        $('.product-modal').removeClass('active');
    })
    $('.shipping-close-modal, .overly-popup').on('click', function () {
        $('#shopify-section-shipping-policy').removeClass('active');
    })

    $('.refund-close-modal, .overly-popup').on('click', function () {
        $('#shopify-section-shipping-policy').removeClass('show');
    })

    $('.redirect-cart').on('click', function () {
        window.location.href = '/cart'
    })

    $('button.upsell-btn').on('click', function (e) {
        e.preventDefault();
        let closestElmnt = `#${e.target.closest('.cart-content-area').dataset.id}`;
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: $(this).parent().serialize(),
            dataType: 'json',
            success: function (data) {
                if (executeOldcode) {
                    fetch('/?section_id=cart-item')
                        .then(response => response.text())
                        .then(cartData => {
                            var cart_html = $(cartData);
                            let findClosestElement = $(closestElmnt, cart_html);

                            var cart_items = $(`${closestElmnt} .cart-items`, cart_html);
                            var freeship_data = $(`${closestElmnt} .cart__fs`, cart_html);

                            $('.cart-items').replaceWith(cart_items[0]);
                            $('.cart__fs').replaceWith(freeship_data[0]);

                            var cart_count = $('.cart-item_count', findClosestElement);
                            $('.cart-item_count').replaceWith(cart_count[0]);

                            var cart_count2 = $('.cart-item-count-new', findClosestElement);
                            $('.cart-item-count-new').replaceWith(cart_count2[0]);

                            
                            var cart_count_total = $('.cart-subtotal', findClosestElement);
                            $('.cart-subtotal').replaceWith(cart_count_total[0]);
                        })
                } else {
                    handleGiftProductAdd(closestElmnt);
                    document.getElementById("shopify-section-cart-item").scrollIntoView({ behavior: 'smooth' });
                }
            },
            error: function (err) {
                console.log('error');
            }
        });
    });
})

//Removing products
// const handleProductsRemove = (formData, closestElmnt) => {
//     fetch('/cart/change.js', {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json'
//         },
//         body: JSON.stringify(formData)
//     })
//         .then(response => {
//             return response.json();
//         })
//         .then(res => {
//             console.log("RES AFTER handleProductsRemove", res);
//             reRenderingDom(closestElmnt);
//         })
//         .catch((error) => {
//             console.error('Error:', error);
//         });
// }


//Rendering cart DOM
const reRenderingDom = (closestElmnt) => {
    fetch('/?section_id=cart-item')
        .then(response => response.text())
        .then(cartData => {
            var cart_html = $(cartData);
            let findClosestElement = $(closestElmnt, cart_html);

            var cart_items = $(`${closestElmnt} .cart-items`, cart_html);
            var freeship_data = $(`${closestElmnt} .cart__fs`, cart_html);

            $('.cart-items').replaceWith(cart_items[0]);
            $('.cart__fs').replaceWith(freeship_data[0]);

            var cart_count = $('.cart-item_count', findClosestElement);
            $('.cart-item_count').replaceWith(cart_count[0]);
          
            var cart_count2 = $('.cart-item-count-new', findClosestElement);
            $('.cart-item-count-new').replaceWith(cart_count2[0]);

            
            var cart_count_total = $('.cart-subtotal', findClosestElement);
            $('.cart-subtotal').replaceWith(cart_count_total[0]);
        })
}

//Removing products if price doesn't match with the selected products
const handleProductsRemove = (formData, closestElmnt) => {
    let itemsCount = formData.items.length;
    let counter = 0;
    formData.items.map(item => {
        counter++;
        $.ajax({
            type: "POST",
            url: "/cart/change.js",
            dataType: "json",
            data: item
        }).then((data) => {
            if (counter == itemsCount) {
                reRenderingDom(closestElmnt);
                // setTimeout(function () {
                //     reRenderingDom(closestElmnt);
                // }, 'fast');
            }
        })
    })
}
const handleProductsRemove2 = (closestElmnt) => {
    fetch('/cart.js', {
        method: 'GET'
    }).then(res => res.json())
        .then(res => {
            return res;
        })
        .then(res => {
            let price = res.items_subtotal_price;
            let data = {
                updates: {
                }
            }

            productsArray.map((item, index) => {
                if (index != 0) {
                    if (price < item.price) {

                        // Strong products that needs to removee
                        res.items.map(resItem => {
                            if (resItem.id == item.productId) {
                                data.updates[resItem.id] = 0

                                // setTimeout(() => {
                                //     $.ajax({
                                //         type: "POST",
                                //         url: "/cart/update.js",
                                //         dataType: "json",
                                //         data: {
                                //             id: parseInt(item.productId),
                                //             quantity: 0,
                                //         }
                                //     }).then((data) => {
                                //         reRenderingDom(closestElmnt);
                                //     })
                                // }, 5000)
                            }
                        });
                    }
                }
            });

            console.log("DATA TO SEND", data)
            jQuery.post(window.Shopify.routes.root + 'cart/update.js', data)

                .then(response => {
                    reRenderingDom(closestElmnt);
                })
                .catch((error) => {
                    console.error('Error:', error);
                });


            // $.ajax({
            //     type: 'POST',
            //     url: '/cart/change.js',
            //     data: data,
            //     dataType: 'json',
            //     success: function () {
            //         setTimeout(() => {

            //             reRenderingDom(closestElmnt);
            //         }, 100)
            //     }
            // });

        })

}

//Adding Disounted products based on total price
const handleGiftProductAdd = (closestElmnt, upsel = false) => {
    fetch('/cart.js', {
        method: 'GET'
    }).then(res => res.json())
        .then(res => {
            return res;
        })
        .then(res => {
            let price = res.items_subtotal_price;
            let formData = {
                items: [
                ]
            };

            let productsToRemove = {
                items: [
                ]
            };

            productsArray.map((item, index) => {
                if (index != 0) {
                    if (price >= item.price) {
                        let isProduct = false;
                        res.items.map(resItem => {
                            if (resItem.id == item.productId) {
                                isProduct = true;
                            }
                        });

                        if (!isProduct) {
                            if (item.productId == 40999802896523) {
                                formData.items.push({
                                    id: parseInt(item.productId),
                                    quantity: 1,
                                    selling_plan: 717848715
                                })
                            } else {
                                formData.items.push({
                                    id: parseInt(item.productId),
                                    quantity: 1
                                })
                            }
                        }
                    } else if (price < item.price) {
                        //Strong products that needs to remove
                        res.items.map(resItem => {
                            if (resItem.id == item.productId) {
                                productsToRemove.items.push({
                                    id: parseInt(item.productId),
                                    quantity: 0
                                })
                            }
                        });
                    }
                }
            });

            if (productsToRemove.items.length > 0) {
                handleProductsRemove(productsToRemove, closestElmnt);
            }

            if (formData.items.length > 0) {
                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                })
                    .then(response => {
                        return response.json();
                    })
                    .then(res => {
                        reRenderingDom(closestElmnt);
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    });
            } else {
                reRenderingDom(closestElmnt);
            }
        })
}

// increase item
function itemIncrease(e, el) {
    var myElement = el;
    $input = myElement.previousElementSibling;
    var value = parseInt($input.value);
    if (value < 100) {
        value = value + 1;
    } else {
        value = 100;
    }
    $input.value = value;
    changeQty($input);
};
// decrease item
function itemDecrease(e, el) {
    $input = el.nextElementSibling;
    var value = parseInt($input.value);
    if (value > 1) {
        value = value - 1;
    } else {
        value = 1;
    }
    $input.value = value;
    changeQty($input);
};

function changeQty($input) {
    let closestElmnt = `#${$input.closest('.cart-content-area').dataset.id}`;
    var variant_id = $($input).data("id");
    var quantity = $($input).val();
    var data = { updates: {} };
    data.updates[variant_id] = quantity;
    $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: data,
        dataType: 'json',
        success: function (res) {

            if (executeOldcode) {
                fetch(`/?section_id=cart-item`)
                    .then(response => response.text())
                    .then(cartData => {
                        var cart_html = $(cartData);
                        let findClosestElement = $(closestElmnt, cart_html);

                     

                        var cart_items = $(`${closestElmnt} .cart-items`, cart_html);
                        var freeship_data = $(`${closestElmnt} .cart__fs`, cart_html);

                        $('.cart-items').replaceWith(cart_items[0]);
                        $('.cart__fs').replaceWith(freeship_data[0]);

                        var cart_count = $('.cart-item_count', findClosestElement);
                        $('.cart-item_count').replaceWith(cart_count[0]);

                        var cart_count2 = $('.cart-item-count-new', findClosestElement);
                        $('.cart-item-count-new').replaceWith(cart_count2[0]);

                        var cart_count_total = $('.cart-subtotal', findClosestElement);
                        $('.cart-subtotal').replaceWith(cart_count_total[0]);

                    });
            } else {
                handleGiftProductAdd(closestElmnt);
            }
        },
        error: function (err) {
            console.log('error');
        }
    });
};

function cartRemoveItem(e, el) {
    e.preventDefault();
    let closestElmnt = `#${el.closest('.cart-content-area').dataset.id}`;
    var id = $(el).data('id');
    $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        data: {
            id: id,
            quantity: 0,
        }
    }).then((data) => {
        setTimeout(function () {
            if (executeOldcode) {
                fetch('/?section_id=cart-item')
                    .then(response => response.text())
                    .then(cartData => {
                        var cart_html = $(cartData);
                        let findClosestElement = $(closestElmnt, cart_html);

                        var cart_items = $(`${closestElmnt} .cart-items`, cart_html);
                        var freeship_data = $(`${closestElmnt} .cart__fs`, cart_html);

                        $('.cart-items').replaceWith(cart_items[0]);
                        $('.cart__fs').replaceWith(freeship_data[0]);

                        var cart_count = $('.cart-item_count', findClosestElement);
                        $('.cart-item_count').replaceWith(cart_count[0]);

                        var cart_count2 = $('.cart-item-count-new', findClosestElement);
                        $('.cart-item-count-new').replaceWith(cart_count2[0]);

                        var cart_count_total = $('.cart-subtotal', findClosestElement);
                        $('.cart-subtotal').replaceWith(cart_count_total[0]);

                    });
            } else {
                // reRenderingDom(closestElmnt);
                handleProductsRemove2(closestElmnt)

            }
        }, 'fast');
    });
};




$(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();

    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top
    }, 500);
});